export default __webpack_public_path__ + "static/media/Kaspy-Phone2.d30a9633.webp";